import getApi from '../../api/apisauceConfig'
import { UserSessionDevice } from '../../model/UserSession'

export const getUserSessions = (signal?: AbortSignal) =>
  getApi().get<UserSessionDevice[]>('/users/me/sessions', {}, { signal })
